export class VehicleTradeBuilder {
    constructor() {
        this.properties = {};
    }
    forVehicle(registrationNumber) {
        this.properties.registrationNumber = registrationNumber;
        return this;
    }
    withMileage(mileage) {
        this.properties.mileage = mileage;
        return this;
    }
    withCondition(condition) {
        this.properties.condition = condition;
        return this;
    }
    withComment(comment) {
        this.properties.comments = comment;
        return this;
    }
    build() {
        return this.properties;
    }
}
